module.exports = __webpack_public_path__ + "img/Safe_Secure.4ecb8916.svg";